<template>
  <div>
    <DecommissionChannelGrid 
    :selectedRowsDataSource="selectedRowsData"
    :AllowEditing="true"
    @requested-date-confirm="requestedDateConfirm"
    />
  </div>
</template>
<script>
import DecommissionChannelGrid from "../DecommissionChannelGrid";
export default {
  name: "ConfirmationScreen",
  components: {
    DecommissionChannelGrid
  },
  data() {
    return {
    };
  },
  props: {
    selectedRowsData: Array,
  },
  mounted: function () {},
  computed: {},
  methods: {
    requestedDateConfirm(data){
      this.$emit("requested-date", data);
    }
  },
};
</script>
<style lang="scss" scoped>

</style>